/**
 * CPF (Cadastro de Pessoas Físicas) validation utility
 * Brazilian individual taxpayer registry number
 */

export function stripCPF(cpf) {
  if (!cpf) return '';
  return cpf.replace(/[.\-\s]/g, '');
}

export function formatCPF(cpf) {
  const digits = stripCPF(cpf);
  if (digits.length !== 11) return cpf;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
}

export function maskCPF(cpf) {
  const digits = stripCPF(cpf);
  if (digits.length !== 11) return cpf;
  return `***.${digits.slice(3, 6)}.${digits.slice(6, 9)}-**`;
}

export function validateCPF(cpf) {
  if (!cpf) {
    return { valid: false, error: 'CPF é obrigatório' };
  }

  const digits = stripCPF(cpf);

  if (digits.length !== 11) {
    return { valid: false, error: 'CPF deve conter 11 dígitos' };
  }

  if (!/^\d{11}$/.test(digits)) {
    return { valid: false, error: 'CPF deve conter apenas números' };
  }

  if (/^(\d)\1{10}$/.test(digits)) {
    return { valid: false, error: 'CPF inválido' };
  }

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(digits[i]) * (10 - i);
  }
  let remainder = (sum * 10) % 11;
  if (remainder === 10) remainder = 0;
  if (remainder !== parseInt(digits[9])) {
    return { valid: false, error: 'CPF inválido (dígito verificador incorreto)' };
  }

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(digits[i]) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10) remainder = 0;
  if (remainder !== parseInt(digits[10])) {
    return { valid: false, error: 'CPF inválido (dígito verificador incorreto)' };
  }

  return { valid: true };
}

/**
 * Apply CPF input mask as user types
 * Formats to ___.___.___-__ pattern
 */
export function applyCPFMask(value) {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
}
